import { Link } from "react-router-dom";
import { Lightbulb, ArrowRight } from "lucide-react";
import { articleUrl } from "../../lib/format";

export const TipOfTheDay = ({ tip }) => {
  if (!tip) return null;
  return (
    <section aria-labelledby="tip-heading" className="card-ab relative overflow-hidden bg-ab-warm p-7 sm:p-9" data-testid="tip-of-the-day">
      <div className="pointer-events-none absolute -right-10 -top-10 h-40 w-40 rounded-full bg-ab-accent-soft" />
      <div className="relative">
        <p className="eyebrow flex items-center gap-2"><Lightbulb size={14} /> Tip of the Day</p>
        <h2 id="tip-heading" className="mt-4 font-serif text-2xl font-semibold leading-snug sm:text-3xl" data-testid="tip-of-the-day-title">{tip.title}</h2>
        <p className="mt-3 text-ab-text-2">{tip.excerpt}</p>
        <Link to={articleUrl(tip)} className="btn-ghost mt-5" data-testid="tip-of-the-day-link">Read More <ArrowRight size={15} /></Link>
      </div>
    </section>
  );
};
